/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@material-ui/core";
import { FC } from "react";
import { SearchHeader } from "../components/reports/search-header";
import InventorySearchForm from "../containers/inventory-search-form";
import InventorySearchResults from "../containers/inventory-search-results";
import { InventoryDataProvider } from "../context/inventory-context";

type InventoryPageProps = {};

const InventoryPage: FC<InventoryPageProps> = () => {
  return (
    <InventoryDataProvider>
      <Grid container xs={12} className="content-section">
        <Grid item xs={12}>
          <SearchHeader title="Inventario" />
        </Grid>

        <InventorySearchForm />

        <Grid
          container
          xs={12}
          alignItems="center"
          direction="row"
          style={{
            marginTop: 25,
            marginBottom: 15,
          }}>
          <Grid item xs={12}>
            <hr />
          </Grid>
        </Grid>

        <InventorySearchResults />
      </Grid>
    </InventoryDataProvider>
  );
};

export default InventoryPage;
